import { Product } from "typings/products"

type GetProductByAttrs = (cartItems: Product[], attrs: Pick<Product, "drugType" | "dosageType">) => Product | undefined
export const getProductByAttrs: GetProductByAttrs = (cartItems, { drugType, dosageType }) =>
  cartItems.find(p => p.drugType === drugType && p.dosageType === dosageType)

type HasProductInCart = (cartItems: Product[], attrs: Pick<Product, "drugType" | "dosageType">) => boolean
export const hasProductInCart: HasProductInCart = (cartItems, attrs) => !!getProductByAttrs(cartItems, attrs)

/* catch error if unable to access localstorage and return false */
export const canAccessLocalStorage = () => {
  const test = "checkForLocalStorageAccess"
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}
